import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container } from '@ui';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { ROUTES } from '@constants/routes';

const StateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  padding: 64px 16px;
`;

const ActionWrapper = styled.div`
  padding-top: 16px;
`;

/*
  An account with no documents at all and a filter set that matches none of them are different
  problems with different ways out, so they get different copy.
*/
export const NoDocumentsState = () => (
  <StateWrapper>
    <Body1 bold>No documents yet</Body1>
    <Container top={8}>
      <Body5 isLowContrast>Documents you upload will appear here.</Body5>
    </Container>
    <ActionWrapper>
      {/* Uploading lives on Document Management; the Vault only ever reads. */}
      <SkeletonButton onClick={() => window.open(ROUTES.docManagement, '_self')}>
        Go to Document Management
      </SkeletonButton>
    </ActionWrapper>
  </StateWrapper>
);

export const NoMatchesState = ({ onClearFilters }) => (
  <StateWrapper>
    <Body1 bold>No documents match these filters</Body1>
    <Container top={8}>
      <Body5 isLowContrast>Try widening the date range or removing a filter.</Body5>
    </Container>
    <ActionWrapper>
      <SkeletonButton onClick={onClearFilters}>Clear all filters</SkeletonButton>
    </ActionWrapper>
  </StateWrapper>
);

export const LoadFailedState = ({ onRetry }) => (
  <StateWrapper>
    <Body1 bold>Couldn’t load your documents</Body1>
    <Container top={8}>
      <Body5 isLowContrast>Something went wrong fetching the list. Your filters are still applied.</Body5>
    </Container>
    <ActionWrapper>
      <SkeletonButton onClick={onRetry}>Try again</SkeletonButton>
    </ActionWrapper>
  </StateWrapper>
);
